/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Tag/Form
 * @desc Filter Tag form
 */

import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { Tag } from 'labstep-web/models/tag.model';
import { PostFilterTag } from 'labstep-web/services/postFilter/filters/tag';
import type React from 'react';
import type { IFilterPostNewIndexTagFormProps } from './types';

const FilterPostNewIndexTagForm: React.FC<
  IFilterPostNewIndexTagFormProps
> = ({ addPostFilter, onDone, activeGroup }) => {
  if (!activeGroup) {
    return null;
  }

  return (
    <ParamsStateContextProvider value={{}}>
      <SearchSelect
        entityName={Tag.entityName}
        isClearable
        params={{
          group_id: activeGroup?.id,
        }}
        onChange={(selectedOption) => {
          if (addPostFilter) {
            addPostFilter(
              PostFilterTag.getNode([selectedOption?.guid]),
            );
          }
          onDone();
        }}
      />
    </ParamsStateContextProvider>
  );
};

export default withActiveGroup(FilterPostNewIndexTagForm);
